import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import { useMemo } from "react";

/** The current user's personal connected-apps page in the management app. */
export const usePersonalIntegrationsUrl = () => {
    const { managementAppBaseUrl } = useEnvironmentVariables();

    return useMemo(() => `${managementAppBaseUrl}/profile/integrations`, [managementAppBaseUrl]);
};
